import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const InvoicesPage = lazy(() => import("@/features/invoices/invoices-page"));

export const Route = createFileRoute("/(app)/dashboard/invoices")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <InvoicesPage />
    </Suspense>
  ),
});
